import { render, staticRenderFns } from "./BaseToggleSmallButton.vue?vue&type=template&id=88a11b14&scoped=true"
import script from "./BaseToggleSmallButton.vue?vue&type=script&lang=js"
export * from "./BaseToggleSmallButton.vue?vue&type=script&lang=js"
import style0 from "./BaseToggleSmallButton.vue?vue&type=style&index=0&id=88a11b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a11b14",
  null
  
)

export default component.exports